
<!-- define a menu of items -->
<app-menu-list-item *ngFor="let itemElem of navItems"
					[item]="itemElem">
</app-menu-list-item>